import { render } from "./imageShow.vue?vue&type=template&id=6daa374a"
import script from "./imageShow.vue?vue&type=script&lang=js"
export * from "./imageShow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__